export enum SnackBarType {
  ALERT = 'alert',
  INFO = 'info',
  SUCCESS = 'success',
  UNKNOWN = 'unknown',
}

export interface ISnacksProps {
  id: number | string;
  type: SnackBarType;
  message: string;
  autoHideDuration?: number; // Duration in milliseconds, defaults to no auto-hide
}
